/* eslint-disable react-hooks/exhaustive-deps */
import { ApartmentOutlined, UnorderedListOutlined, } from '@ant-design/icons';
import { Button, Checkbox, Empty, Layout, Modal, Pagination, Row, Select, Tabs, Tooltip, } from 'antd';
import Axios from 'axios';
import { default as classNames, default as clsx } from 'classnames';
import _, { cloneDeep } from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import IconSize65On from '../../assets/icons/5-active.svg';
import IconSize65Off from '../../assets/icons/5-noactive.svg';
import IconSize66On from '../../assets/icons/6-active.svg';
import IconSize66Off from '../../assets/icons/6-noactive.svg';
import IconCameraEmpty from '../../assets/icons/camera-empty.svg';
import IconFullScreen from '../../assets/icons/fullscreen.svg';
import IconSize16Off from '../../assets/icons/size_16_off.svg';
import IconSize16On from '../../assets/icons/size_16_on.svg';
import IconSize4Off from '../../assets/icons/size_4_off.svg';
import IconSize4On from '../../assets/icons/size_4_on.svg';
import IconSize9Off from '../../assets/icons/size_9_off.svg';
import IconSize9On from '../../assets/icons/size_9_on.svg';
import AIView from '../../assets/icons/ai-view.svg';
import AutoPlayOff from '../../assets/icons/auto-play-off.svg';
import AutoPlayOn from '../../assets/icons/auto-play-on.svg';
import { DialPad } from '../../components/DialPad/DialPad';
import Spinner from '../../components/Spinner';
import ViewStreamComponent from '../../components/VideoStream';
import * as SERVICE from '../../constants/service.types';
import * as SYSTEM from '../../constants/system.keys';
import { NOTIFIES, PINNED_CAMERAS, VIEW_STREAM_SERVICE_EXTEND, ZOOM_STATE } from '../../constants/system.keys';
import {
  changeDialPadData,
  clearAlert,
  openMessage,
  setCameraSerials,
  socketEmitEvent,
  toggleSmartMode,
} from '../../redux/actions';
import CameraSearch from '../Camera/CameraSearch';
import TreeCamera from '../Camera/TreeCamera/TreeCamera';
import DndPinCamera from './DndPinCamera';
import PinnedCameraComponent from './PinnedCamera';
import './index.scss';
import {
  getEventsByPersonId,
  getHistoryTrackingEvents,
  getSecurityIdentifications,
  getVirtualWall,
  getWeaponDetection,
} from '../../api/criticalApi';
import moment from 'moment';
import useElementDimensions from "../../hooks/useElementDimensions";
import storageService from '../../services/storage.service';
import AlertBox from "./AlertBox";
import { useHistory } from "react-router-dom";

const { Sider } = Layout;
const { Option } = Select;

const sortByName = (a, b) => {
  if (a?.name < b?.name) {
    return -1;
  }

  if (a?.name > b?.name) {
    return 1;
  }

  return 0;
};

const sortCameras = (cameras) => {
  if (!cameras) {
    return [];
  }

  return cameras.sort(sortByName);
};
const { TabPane } = Tabs;

const LivePage = () => {
  const history = useHistory();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const refCountDown = useRef();
  const [isViewAll, setIsViewAll] = useState(false);
  const [check, setCheck] = useState(0);
  const [ipAddress, setIpAddress] = useState('0.0.0.0');
  const [timeRequest, setTimeRequest] = useState();
  const [visibleTree, setVisibleTree] = useState(false);
  const [isFullscreen, setFullScreen] = useState(false);
  const [modalEnableSmartModeVisible, setModalEnableSmartModeVisible] = useState(false);
  const showModalEnableSmartMode = useRef(null);
  const timer = useRef({});

  const REDUCE_DIMENSIONS = 5;

  const {
    isAuth,
    userId,
    gatewayStates,
    cameraStates,
    namespace,
    dataUser,
    sipAccount,
    dialPad,
    deviceGroup,
    isShowCritical,
    detectionAlerts,
    cameras,
    enabledSmartMode,
    isFilteringAlerts,
    liveCameraSerials
  } = useSelector((state) => state);

  const [pagination, setPagination] = useState({
    page: 1,
    size: 9,
    quality: ZOOM_STATE.THREE,
    grid: [3,3]
  });
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [selectCamera, setSelectCamera] = useState();
  const [gateways, setGateways] = useState();
  const [pinnedCamera, setPinnedCamera] = useState();
  const [data, setData] = useState();
  const [isSyncing, setIsSyncing] = useState(true);
  const [checkGroup, setCheckGroup] = useState(0);
  const [nameGroup, setNameGroup] = useState('');
  const [dataArrGroup, setDataArrGroup] = useState([]);
  const [countDown, setCountDown] = useState();
  const [dataInterval, setDataInterval] = useState(0);

  const handleFullScreen = useFullScreenHandle();

  const { dimensions, ref } = useElementDimensions(data);

  useEffect(() => {
    setTimeRequest(new Date().getTime());
    return () => {
      setTimeRequest(null);
      setIsViewAll(false);
      setIpAddress(null);
      setVisibleTree(false);
      setSelectCamera(null);
      setGateways(null);
      setPinnedCamera(null);
      setData(null);
      setIsSyncing(true);
    };
  }, []);

  useEffect(() => {
    let refClear;
    if (isSyncing) {
      refClear = setTimeout(() => {
        setIsSyncing(false);
      }, 2000);
    }
    return () => {
      clearInterval(refClear);
    };
  }, [isSyncing]);

  useEffect(() => {
    if (checkGroup === 0) {
      if (pinnedCamera && pagination) {
        setData(
            pinnedCamera.sort(sortByName).slice(
              (pagination.page - 1) * pagination.size,
              pagination.page * pagination.size
            )
        );
      } else {
        setData([]);
        setGateways([]);
      }
    } else {
      if (dataArrGroup && pagination) {
        setData(
            dataArrGroup.sort(sortByName).slice(
              (pagination.page - 1) * pagination.size,
              pagination.page * pagination.size
            )
        );
      } else {
        setData([]);
        setGateways([]);
      }
    }
  }, [checkGroup, dataArrGroup, pagination, pinnedCamera]);

  useEffect(() => {
    async function getInternalGateway(link, serial) {
      try {
        let result = await Axios.get(link);
        return result.status === 200 && result.data.serial === serial;
      } catch (error) {
        return false;
      }
    }
    if (gatewayStates && gatewayStates.requestId === requestId && ipAddress) {
      setGateways(
        gatewayStates.data.filter((gateway) => {
          if (
            ipAddress &&
            gateway.state === 1 &&
            gateway.ipAddress &&
            gateway.ipAddress === ipAddress &&
            gateway.localAddress &&
            gateway.localAddress.length > 0
          ) {
            return getInternalGateway(
              `http://${gateway.localAddress}:${gateway.portScan}/info`,
              gateway.serial
            );
          }
          return false;
        })
      );
    }
  }, [gatewayStates, ipAddress]);

  useEffect(() => {
    if (isAuth === 1 && namespace && timeRequest) {
      let data = {
        deviceType: 'camera',
        page: 0,
        size: 10,
        timeRequest,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace, timeRequest]);

  useEffect(() => {
    if (countDown === 0) {
      setCountDown(dataInterval);
      clearInterval(refCountDown.current);
      refCountDown.current = setInterval(() => {
        setCountDown((timer) => timer - 1);
      }, 1000);
      const total =
        checkGroup === 0
          ? pinnedCamera && pinnedCamera.length
          : dataArrGroup && dataArrGroup.length;
      const pageSize = pagination.size;
      const currentPage = pagination.page;
      if (total - currentPage * pageSize > 0) {
        setPagination((state) => ({ ...state, page: currentPage + 1 }));
      } else {
        setPagination((state) => ({ ...state, page: 1 }));
      }
    }
  }, [countDown]);

  useEffect(() => {
    if (localStorage.getItem('auto_play') === 'on') {
      setTimeout(() => {
        setIsViewAll(true);
      }, 500)
    }
    return () => clearInterval(refCountDown.current);
  }, []);

  const cameraDimensions = useMemo(() => {
      const { grid } = pagination;
      const { width: containerWidth, height: containerHeight } = dimensions || {};
      return {
        width: (containerWidth / grid?.[0]) - REDUCE_DIMENSIONS,
        height: (containerHeight / grid?.[1]) - REDUCE_DIMENSIONS,
      }
  }, [dimensions, pagination.grid])

  const onSyncPinned = useCallback(() => {
    const data = {
      configuration: {
        userId,
        cameras: pinnedCamera?.map((camera) => camera.serial) ?? [],
      },
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_USER_INFO,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    setIsSyncing(true);
    return dispatch(socketEmitEvent(dataObj));
  }, [dispatch, pinnedCamera, userId, namespace]);

  const getPinnedLocal = useCallback((namespace, userId) => {
    if (namespace && userId) {
      let hashKey = `${PINNED_CAMERAS}.${namespace}.${userId}`;
      let localData = localStorage.getItem(hashKey);
      if (localData) {
        return JSON.parse(localData).data;
      }
      return undefined;
    }
  }, []);

  const changeLocalStorage = useCallback(
    (cameras) => {
      if (namespace && userId) {
        const data = {
          modification: new Date().getTime(),
          data: cameras,
        };
        let hashKey = `${PINNED_CAMERAS}.${namespace}.${userId}`;
        return localStorage.setItem(hashKey, JSON.stringify(data));
      }
    },
    [namespace, userId]
  );
  useEffect(() => {
    if (pinnedCamera?.length > 0) {
      changeLocalStorage(pinnedCamera.map((camera) => camera.serial));
    }
  }, [changeLocalStorage, pinnedCamera, userId]);

  /**
   * @deviceSerials array
   */
  const getDeviceStates = useCallback(
    (deviceSerials) => {
      let data = {
        namespace,
        serials: deviceSerials.join(';'),
      };
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest);
      let dataObj = {
        appServiceType: SERVICE.LIST_STATE_DEVICES,
        requestId: dataTimeRequest,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  const onUpdatePinCamera = useCallback(
    (currentPin) => {
      if (currentPin.length > 0) {
        getDeviceStates(currentPin);
      } else {
        setPinnedCamera([]);
        changeLocalStorage([]);
      }
      return setVisibleTree(false);
    },
    [changeLocalStorage, getDeviceStates]
  );

  useEffect(() => {
    if (userId && dataUser && namespace) {
      let cameras = getPinnedLocal(namespace, userId);
      if (cameras) {
        if (cameras.length > 0) {
          getDeviceStates(cameras);
        } else {
          setPinnedCamera([]);
        }
      } else if (dataUser.configuration) {
        const { cameras: serials } = JSON.parse(dataUser.configuration);
        if (serials && serials.length > 0) {
          setIsSyncing(true);
          getDeviceStates(serials);
        } else {
          setPinnedCamera([]);
        }
      } else {
        setVisibleTree(true);
        setPinnedCamera([]);
      }
    } else {
      setPinnedCamera([]);
    }
  }, [dataUser, getDeviceStates, getPinnedLocal, namespace, userId]);

  const unpinCamera = (serial) => {
    setPinnedCamera((state) =>
      state.filter((camera) => camera.serial !== serial)
    );
  };

  const pinCamera = useCallback(
    (camera) => {
      if (!pinnedCamera?.some((cam) => cam.serial === camera.serial)) {
        setPinnedCamera((state) => state.concat(camera));
      } else {
        openMessage(
          NOTIFIES.ERROR,
          t('_CAMERA WAS PINNED', { name: camera.name })
        );
      }
    },
    [pinnedCamera, t]
  );

  const addCameraGroup = (camera) => {
    if (!dataArrGroup.some((cam) => cam.serial === camera.serial)) {
      const dataGroup = [...dataArrGroup, camera];
      setDataArrGroup(dataGroup);
      let data = {
        namespace,
        deviceGroupId: checkGroup,
        name: nameGroup,
        deviceInfos:
          (dataGroup &&
            dataGroup.length > 0 &&
            dataGroup.map((item, index) => ({
              serial: item.serial,
              indexOf: index + 1,
            }))) ||
          [],
      };
      let dataObj = {
        appServiceType: SERVICE.UPDATE_DEVICE_GROUP,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    } else {
      openMessage(
        NOTIFIES.ERROR,
        t('_CAMERA WAS ADDED', { name: camera.name })
      );
    }
  };

  const deleteCameraGroup = (camera) => {
    const dataGroup = dataArrGroup.filter(
      (item) => item.serial !== camera.serial
    );
    setDataArrGroup(dataGroup);
    let data = {
      namespace,
      deviceGroupId: checkGroup,
      name: nameGroup,
      deviceInfos:
        (dataGroup &&
          dataGroup.length > 0 &&
          dataGroup.map((item, index) => ({
            serial: item.serial,
            indexOf: index + 1,
          }))) ||
        [],
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_DEVICE_GROUP,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const requestGetSipAccount = () => {
    let data = {
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.REQUEST_MAKE_CALL_OUT,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  useEffect(() => {
    if (
      cameraStates &&
      cameraStates.data &&
      cameraStates.data.length > 0 &&
      check === 0
    ) {
      setCheck(check + 1);

      let gatewaySerials = [
        ...new Set(cameraStates.data.map((item) => item.gatewaySerial)),
      ];
      getDeviceStates(gatewaySerials);
    }
  }, [cameraStates, getDeviceStates, check]);

  useEffect(() => {
    if (namespace) {
      requestGetSipAccount();
    }
  }, [namespace]);

  useEffect(() => {
    if (
      cameraStates &&
      cameraStates.requestId === requestId &&
      cameraStates.data
    ) {
      setPinnedCamera(
        cameraStates.data.filter((device) => device.ownerId !== -1)
      );
    } else {
      if (!pinnedCamera) {
        setPinnedCamera([]);
      }
    }
  }, [cameraStates]);

  const getDeviceByPage = useCallback(
    (page, size) => {
      if (isAuth === 1 && namespace && timeRequest) {
        let data = {
          namespace,
          deviceType: 'camera',
          timeRequest,
          page,
          size,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, isAuth, namespace, timeRequest]
  );

  const onChangeCamera = (values, data, name) => {
    setCheckGroup(values);
    setNameGroup(name);
    setDataArrGroup(data);
    setPagination((state) => ({
      ...state,
      size: 9,
      page: 1,
      quality: ZOOM_STATE.THREE,
    }))
  };

  const compare = (a, b) => {
    if (a.resolution > b.resolution) {
      return -1;
    }
    if (a.resolution < b.resolution) {
      return 1;
    }
    return 0;
  };

  const onCheckZoomState = (
    dataArr,
    zoomState,
    zoomStateDefault,
    resolutionDefault
  ) => {
    if (zoomState >= 0) {
      if (dataArr?.find((item) => item.zoomState === zoomState)) {
        return {
          dataZoomStates: [...dataArr],
          zoomState,
          resolution: dataArr?.find((item) => item.zoomState === zoomState)
            ?.resolution,
        };
      } else {
        return onCheckZoomState(
          dataArr,
          zoomState - 1,
          zoomStateDefault,
          resolutionDefault
        );
      }
    } else {
      return {
        dataZoomStates: [...dataArr],
        zoomState: zoomStateDefault,
        resolution: resolutionDefault,
      };
    }
  };

  const onZoomState = (camera) => {
    const defaultQualityLevel = sessionStorage.getItem(
      SYSTEM.DEFAULT_QUALITY_LEVEL
    );

    let dataZoomState =
      (camera?.subSources &&
        JSON.parse(camera?.subSources)?.map((item) => ({
          resolution: item.resolution,
          zoomState: item.zoomState,
        }))) ??
      [];
    if (
      !dataZoomState?.find((item) => item.resolution === camera?.resolution)
    ) {
      dataZoomState = [
        ...dataZoomState,
        {
          resolution: camera?.resolution,
          zoomState: camera?.zoomState,
        },
      ];
    }
    const dataArr = dataZoomState
      ?.filter((item) => item.resolution >= 0 && item.zoomState >= 0)
      ?.sort(compare);
    const zoomState = null;
    const dataTemp = onCheckZoomState(
      dataArr,
      zoomState,
      camera?.zoomState,
      camera?.resolution
    );
    const dataZoomStateMin = _.minBy(dataTemp?.dataZoomStates, 'resolution');
    const dataTemp1 = {
      ...dataTemp,
      resolution: dataZoomStateMin?.resolution ?? camera?.resolution,
      zoomState: dataZoomStateMin?.zoomState ?? camera?.zoomState,
    };
    return dataTemp1;
  };

  const handleInterval = (value) => {
    if (value === 0) {
      setIsViewAll(false);
      setCountDown(null);
      setDataInterval(0);
      clearInterval(refCountDown.current);
    } else {
      setIsViewAll(true);
      setCountDown(value);
      setDataInterval(value);
      clearInterval(refCountDown.current);
      refCountDown.current = setInterval(() => {
        setCountDown((timer) => timer - 1);
      }, 1000);
    }
  };

  const modeButtonsComponent = (pageSize) => (
    <div className="mode-button">
      <Tooltip placement="bottom" title={t('Toggle full screen view')}>
        <div onClick={handleFullScreen.enter} className="mode">
          <img src={IconFullScreen} alt="mode"/>
        </div>
      </Tooltip>
      <Tooltip placement="bottom" title={t('Toggle to 2x2 view mode')}>
        <div
          onClick={() =>
            pageSize !== 4 &&
            setPagination((state) => ({
              ...state,
              size: 4,
              page: 1,
              quality: ZOOM_STATE.THREE,
              grid: [2, 2]
            }))
          }
          className="mode"
        >
          <img src={pageSize === 4 ? IconSize4On : IconSize4Off} alt="mode"/>
        </div>
      </Tooltip>
      <Tooltip placement="bottom" title={t('Toggle to 3x3 view mode')}>
        <div
          onClick={() =>
            pageSize !== 9 &&
            setPagination((state) => ({
              ...state,
              size: 9,
              page: 1,
              quality: ZOOM_STATE.THREE,
              grid: [3, 3]
            }))
          }
          className="mode"
        >
          <img src={pageSize === 9 ? IconSize9On : IconSize9Off} alt="mode"/>
        </div>
      </Tooltip>
      <Tooltip placement="bottom" title={t('Toggle to 4x4 view mode')}>
        <div
          onClick={() =>
            pageSize !== 16 &&
            setPagination((state) => ({
              ...state,
              size: 16,
              page: 1,
              quality: ZOOM_STATE.TWO,
              grid: [4, 4]
            }))
          }
          className="mode"
        >
          <img
            src={pageSize === 16 ? IconSize16On : IconSize16Off}
            alt="mode"
          />
        </div>
      </Tooltip>
      <Tooltip placement="bottom" title={t('Toggle to 6x5 view mode')}>
        <div
          onClick={() =>
            pageSize !== 30 &&
            setPagination((state) => ({
              ...state,
              size: 30,
              page: 1,
              quality: ZOOM_STATE.ONE,
              grid: [6, 5]
            }))
          }
          className="mode per6"
        >
          <img
            src={pageSize === 30 ? IconSize65On : IconSize65Off}
            alt="mode"
          />
        </div>
      </Tooltip>
      <Tooltip placement="bottom" title={t('Toggle to 6x6 view mode')}>
        <div
          onClick={() =>
            pageSize !== 36 &&
            setPagination((state) => ({
              ...state,
              size: 36,
              page: 1,
              quality: ZOOM_STATE.ONE,
              grid: [6, 6]
            }))
          }
          className="mode per6"
        >
          <img
            src={pageSize === 36 ? IconSize66On : IconSize66Off}
            alt="mode"
          />
        </div>
      </Tooltip>
      <Select
        className="header-camera-select"
        placeholder={t('Interval')}
        value={dataInterval}
        onChange={handleInterval}
      >
        <Option value={0}>{t('Off autoload')}</Option>
        <Option value={120}>2 {t('minutes')}</Option>
        <Option value={300}>5 {t('minutes')}</Option>
        <Option value={600}>10 {t('minutes')}</Option>
        <Option value={1800}>30 {t('minutes')}</Option>
      </Select>
      <div
        style={{cursor: "pointer", display: "flex", alignItems: "center"}}
        onClick={() => {
          setIsViewAll(prevState => !prevState);
        }}
      >
        <img src={isViewAll ? AutoPlayOn : AutoPlayOff} alt="auto-play"/>
      </div>
      <span style={{alignSelf: 'center', display: 'inline-block', marginRight: '16px', marginLeft: "4px"}}>{t('Auto play')}</span>
      <div
        style={{cursor: "pointer", display: "flex", alignItems: "center"}}
        onClick={() => {
          const showModalEnableSmartMode = localStorage.getItem('showModalEnableSmartMode');
          if (showModalEnableSmartMode === null || !!Number(showModalEnableSmartMode)) {
            setModalEnableSmartModeVisible(true);
          } else {
            dispatch(toggleSmartMode(true));
            handleFullScreen.enter();
          }
        }}
      >
        <img width={45} src={AIView} alt="ai-view"/>
      </div>
    </div>
  );
  const [currentCameraGroup, setCurrentCameraGroup] = useState(null);
  const [tabActive, setTabActive] = useState('1');
  const onChangeSelect = (option) => {
    if (option.value === 0) {
      onChangeCamera(0, data);
      setCurrentCameraGroup(null);
    } else {
      setCurrentCameraGroup(option);
      const dataTimeRequest = new Date().getTime();
      setTimeRequest(dataTimeRequest);
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
          requestId: dataTimeRequest,
          body: JSON.stringify({
            namespace,
            deviceGroupId: option?.id,
            timeRequest: dataTimeRequest,
          }),
        })
      );
    }
  };

  const [select, setSelect] = useState();
  useEffect(() => {
    if (selectCamera && selectCamera.serial) {
      setSelect(selectCamera.serial);
    }
  }, [selectCamera?.serial]);

  useEffect(() => {
    // get detail device group data
    if (deviceGroup?.requestId === timeRequest && deviceGroup?.deviceGroup) {
      onChangeCamera(
        deviceGroup?.deviceGroup?.id,
        deviceGroup?.deviceGroup?.devices || [],
        deviceGroup?.deviceGroup?.name || ''
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceGroup]);

  const [listSerialEvent, setListSerialEvent] = useState([]);
  const getEventBeforeCurrent = async (fromTime, toTime) => {
    const token = storageService.getInternalStorageByKey(SYSTEM.DECODED_ACCESS_TOKEN);
    const query = {
      token,
      dataHeader: { namespace },
      dataQuery: {
        fromTime: fromTime,
        toTime: toTime,
        customerNamespace: namespace,
        isDownload: 0,
        limit: 1000,
        offset: 0,
      },
    };
    Promise.all([
      getVirtualWall(query), //tường rào ảo
      getWeaponDetection(query), // hung khí
      getHistoryTrackingEvents(query), // theo dõi
      getEventsByPersonId({
        token,
        dataHeader: {
          namespace: '',
          tenantId: namespace,
        },
        dataQuery: {
          fromTime: fromTime,
          toTime: toTime,
          limit: 1000,
          offset: 0,
          personId: '',
        },
      }), // Nhận diện
      getSecurityIdentifications(query), // xâm nhập
    ]).then((values) => {
      const serialNameSet = new Set();

      values[0].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[1].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[2].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[3].data.cdrs.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });
      values[4].data.records.forEach((record) => {
        if (record?.serial) {
          serialNameSet.add(record.serial);
        }
      });

      const serialName = Array.from(serialNameSet);
      setListSerialEvent(serialName);
    });
  };

  useEffect(() => {
    // event để test
    // getEventBeforeCurrent(1720630800, 1720717199);
    if (isShowCritical)
      getEventBeforeCurrent(
        moment().startOf('day').unix(),
        moment().endOf('day').unix()
      );
  }, [isShowCritical]);

  const getOldestActiveCamera = () => {
    const clonedData = cloneDeep(data);
    const clonedEvents = cloneDeep(detectionAlerts);

    const initialGroupActiveTimeByCamera = clonedData.reduce((acc, cur) => {
      acc[cur.serial] = [];
      return acc;
    }, {})

    const groupActiveTimeByCamera = clonedEvents.reduce((acc, cur) => {
      acc[cur.serial] = acc[cur.serial] ? [...acc[cur.serial], cur.actionTime] : [cur.actionTime];
      return acc;
    }, initialGroupActiveTimeByCamera)

    for(const key in groupActiveTimeByCamera) {
      groupActiveTimeByCamera[key] = groupActiveTimeByCamera[key]?.length ? groupActiveTimeByCamera[key][groupActiveTimeByCamera[key].length - 1] : '';
    }

    const sortedCameraByLastActiveTime = Object.entries(groupActiveTimeByCamera).sort((a, b) => a[1] - b[1]);
    return sortedCameraByLastActiveTime[0][0];
  }

  const reorderCamera = () => {
    let clonedData = cloneDeep(data);
    const clonedEvents = cloneDeep(detectionAlerts);
    const availableCameras = cloneDeep(cameras?.data);
    const newestActiveCamera = clonedEvents[0];
    const shouldUpdateCurrentCameraView = clonedData.every(item => item?.serial !== newestActiveCamera?.serial);
    if (shouldUpdateCurrentCameraView) {
      const newCamera = availableCameras.find(camera => camera.serial === newestActiveCamera?.serial);
      const isFullCamera = clonedData.length === (pagination.grid[0] * pagination.grid[1]);

      if (!isFullCamera) {
        setData(prev => ([
          ...prev,
          newCamera
        ]))
      }

      if (isFullCamera) {
        const oldestActiveCameraSerial = getOldestActiveCamera();
        const oldestActiveCameraIndex = clonedData?.findIndex(item => item.serial === oldestActiveCameraSerial);

        if (oldestActiveCameraIndex !== -1) {
          (clonedData || []).splice(oldestActiveCameraIndex, 1, newCamera);
          setData(clonedData);
        }
      }
    }
    // set timeout for first render
    setTimeout(() => {
      toggleClass(newestActiveCamera?.serial);
    })
  }

  const onSelectAlert = (alert) => {
    setSelectCamera(alert);
  }

  const toggleClass = (serial) => {
    const camera = document.querySelector(`[data-serial="${serial}"]`);
    if (camera) {
      const isAlerting = camera.classList.contains("alerting");
      if (!isAlerting) {
        camera.classList.add("alerting");
      } else {
        if (timer.current[serial]) {
          clearTimeout(timer.current[serial]); //cancel the previous timer.
          timer.current[serial] = null;
        }
      }
      timer.current[serial] = setTimeout(() => {
        camera.classList.remove("alerting")
      }, 5000);
    }
  }

  useEffect(() => {
    if (detectionAlerts && detectionAlerts.length && enabledSmartMode) {
      reorderCamera();
    }
  }, [detectionAlerts]);

  useEffect(() => {
    localStorage.setItem('auto_play', isViewAll ? 'on' : 'off');
  }, [isViewAll]);

  return (
    <div className="camera-component">
      <Modal
        title={t("Enable smart mode?")}
        visible={modalEnableSmartModeVisible}
        onCancel={() => setModalEnableSmartModeVisible(false)}
        footer={[
          <Button onClick={() => setModalEnableSmartModeVisible(false)}>
            {t('Cancel')}
          </Button>,
          <Button type="primary" onClick={() => history.push('/service')}>
            Go to service page
          </Button>,
          <Button
            type="primary"
            onClick={() => {
              dispatch(toggleSmartMode(true));
              handleFullScreen.enter();
              setModalEnableSmartModeVisible(false);
              const show = !showModalEnableSmartMode.current;
              localStorage.setItem('showModalEnableSmartMode', show ? '1' : '0');
            }}
          >
            {t('Continue')}
          </Button>,
        ]}
      >
        <div>{t('To activate smart mode')}</div>
        <ul>
          <li>{t('Someone has entered the restricted area - DETECT_OBJECT')}</li>
          <li>{t('Someone appeared - DETECT_PERSON')}</li>
          <li>{t('Someone is carrying a weapon - DETECT_WEAPON')}</li>
          <li>{t('Fire smoke detection - DETECT_FIRE')}</li>
          <li>{t('There is an object crossing the fence - DETECT_VIRTUAL_WALL')}</li>
          <li>{t("Recognize object's face - RECOGNITION_FACE(529)")}</li>
        </ul>
        <Checkbox
          defaultChecked={false}
          onChange={event => {
            showModalEnableSmartMode.current = event.target.checked;
          }}
        >
          {t('Do not show this again')}
        </Checkbox>
      </Modal>
      <Layout>
        <Sider width={pagination.size === 36 ? 340 : 324}>
          <Tabs
            defaultActiveKey="1"
            onChange={(value) => {
              setTabActive(value);
              setCheckGroup(0);
              setCurrentCameraGroup(null);
            }}
          >
            <TabPane
              tab={
                <span>
                  <UnorderedListOutlined />
                  {t('List')}
                </span>
              }
              key="1"
            />

            <TabPane
              tab={
                <span>
                  <ApartmentOutlined />
                  {t('Tree')}
                </span>
              }
              key="2"
            />
          </Tabs>
          <div className="live-tab-content">
            {/* For tab List */}
            {tabActive == 1 && (
              <>
                <div className="search-camera">
                  <CameraSearch
                    value={currentCameraGroup}
                    onChangeSelect={onChangeSelect}
                    checkGroup={checkGroup}
                    getDeviceByPage={getDeviceByPage}
                    pinnedCamera={pinnedCamera}
                    onUpdatePinCamera={onUpdatePinCamera}
                    visibleTree={visibleTree}
                    setVisibleTree={setVisibleTree}
                    mode="live"
                    labelDefault={tabActive === '1' ? 'Custom' : 'All group'}
                  />
                </div>
                <PinnedCameraComponent
                  pinCamera={pinCamera}
                  selected={selectCamera && selectCamera.serial}
                  setSelectCamera={setSelectCamera}
                  dispatch={dispatch}
                  data={checkGroup === 0 ? pinnedCamera : dataArrGroup}
                  setVisibleTree={setVisibleTree}
                  unpinCamera={unpinCamera}
                  setPinnedCamera={setPinnedCamera}
                  onChangeCamera={onChangeCamera}
                  checkGroup={checkGroup}
                  addCameraGroup={addCameraGroup}
                  setDataArrGroup={setDataArrGroup}
                  deleteCameraGroup={deleteCameraGroup}
                  getDeviceByPage={getDeviceByPage}
                  pinnedCamera={pinnedCamera}
                  onUpdatePinCamera={onUpdatePinCamera}
                  visibleTree={visibleTree}
                  timeRequest={timeRequest}
                />
              </>
            )}

            {/* For tab Tree */}
            {tabActive == 2 && !currentCameraGroup && (
              <TreeCamera
                mode="live"
                onChangeSelect={onChangeSelect}
                setTimeRequest={setTimeRequest}
                pinCamera={pinCamera}
                pinnedCamera={pinnedCamera}
                unpinCamera={unpinCamera}
                setSelect={setSelectCamera}
                current={select}
              />
            )}
            {(tabActive == 1 || (tabActive == 2 && currentCameraGroup)) && (
              <div className="main-pinned-component">
                <DndPinCamera
                  data={checkGroup === 0 ? pinnedCamera : dataArrGroup}
                  select={select}
                  unpinCamera={unpinCamera}
                  setPinnedCamera={setPinnedCamera}
                  setSelectCamera={setSelectCamera}
                  checkGroup={checkGroup}
                  setDataArrGroup={setDataArrGroup}
                  deleteCameraGroup={deleteCameraGroup}
                />
                {/* </DndProvider> */}
                {checkGroup === 0 && pinnedCamera?.length === 0 && (
                  <Empty
                    style={{ margin: 80 }}
                    image={IconCameraEmpty}
                    imageStyle={{
                      height: 60,
                    }}
                    description={<span>{t('No cameras!')}</span>}
                  >
                    <Button
                      onClick={() => setVisibleTree((state) => !state)}
                      type="primary"
                    >
                      {t('Pin camera')}
                    </Button>
                  </Empty>
                )}

                {checkGroup !== 0 && dataArrGroup?.length === 0 && (
                  <Empty
                    style={{ margin: 80 }}
                    image={IconCameraEmpty}
                    imageStyle={{
                      height: 60,
                    }}
                    description={<span>{t('No cameras!')}</span>}
                  />
                )}
              </div>
            )}
          </div>
        </Sider>
        <Layout>
          <div
            className="header-camera-component"
            style={{
              width: `calc(100% - ${pagination.size === 36 ? 360 : 332}px)`,
            }}
          >
            {modeButtonsComponent(pagination.size)}

            <div className="pagination">
              <Pagination
                current={pagination.page}
                onChange={(value) =>
                  setPagination((state) => ({ ...state, page: value }))
                }
                total={
                  checkGroup === 0
                    ? pinnedCamera && pinnedCamera.length
                    : dataArrGroup && dataArrGroup.length
                }
                pageSize={pagination.size}
              />
            </div>
          </div>
          <div className="main-camera-component">
            {gateways ? (
              data && data.length > 0 ? (
                <FullScreen handle={handleFullScreen} onChange={isFullScreen => {
                  setFullScreen(isFullScreen);
                    //handle reset layout => fix break layout after toggle fullscreen mode
                  setPagination(prevState => ({...prevState, grid: prevState.grid}));
                  if (!isFullScreen) {
                    dispatch(toggleSmartMode(false));
                    dispatch(clearAlert([]));
                    setSelectCamera(null);
                  }
                } } >
                  <Row
                    ref={ref}
                    onDoubleClick={() => {
                      handleFullScreen.exit();
                      setFullScreen(false);
                      dispatch(toggleSmartMode(false));
                      dispatch(clearAlert([]));
                    }}
                    gutter={[4, 4]}
                    className={clsx('main-live-page', {
                      fullscreen: handleFullScreen.active,
                      noneFullScreen: !handleFullScreen.active,
                    })}
                    id='main-live-page'
                    style={{
                      padding: (isFullscreen && enabledSmartMode) ? "8px" : "",
                      display: "grid",
                      gridTemplateColumns: `repeat(${pagination.grid?.[0]}, 1fr)`,
                      gridTemplateRows: `repeat(${pagination.grid?.[1]}, 1fr)`,
                      width: (isFullscreen && !enabledSmartMode) ? '100%' : `calc(100% - ${pagination.size === 36 ? 350 : 332}px)`,
                      height: `calc(100vh - 108px)`,
                    }}
                  >
                    {data.map((camera) => (
                        <div
                          key={camera.serial}
                          data-serial={camera.serial}
                          style={{
                            height: cameraDimensions.height,
                            width: '100%',
                            padding: '4px'
                          }}
                          className={classNames({
                            'camera-container': true,
                            'fullscreen': isFullscreen,
                            selected:
                              selectCamera &&
                              selectCamera.serial &&
                              camera.serial === selectCamera.serial,
                            'show-border': listSerialEvent.includes(
                              camera.serial,
                            ),
                          })}
                        >
                          <ViewStreamComponent
                            allScreen={handleFullScreen.active}
                            isViewAll={isViewAll}
                            zoomState={onZoomState(camera)}
                            name={camera.name}
                            typeCamera={camera.typeCamera}
                            resolution={camera.resolution}
                            serviceId={VIEW_STREAM_SERVICE_EXTEND.normal}
                            state={camera.state}
                            serial={camera.serial}
                            gatewaySerial={camera.gatewaySerial}
                            thumbnail={camera.thumbnail}
                            isInternal={
                              gateways &&
                              gateways.some(
                                (gateway) =>
                                  gateway.serial === camera.gatewaySerial
                              )
                            }
                            permission={camera.permission}
                            isAllowStreaming={camera.isAllowStreaming}
                          />
                        </div>
                    ))}
                  </Row>
                  <>
                    {
                      (isFullscreen && enabledSmartMode) && (
                        <AlertBox
                          events={detectionAlerts}
                          pagination={pagination}
                          onSelect={onSelectAlert}
                          setPagination={setPagination}
                          gateways={gateways}
                          data={data}
                        />
                      )
                    }

                    {
                      (isFullscreen && !enabledSmartMode) && (
                        <div
                          style={{
                            position: "fixed",
                            right: "-10px",
                            bottom: "-15px",
                            width: "50px",
                            height: "50px",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            style={{cursor: "pointer", display: "flex", alignItems: "center"}}
                            onClick={() => {
                              dispatch(toggleSmartMode(true))
                            }}
                          >
                            <img src={AIView} alt="ai-view"/>
                          </div>
                        </div>
                      )
                    }
                  </>
                </FullScreen>
              ) : (
                <Empty
                  style={{margin: 80}}
                  image={IconCameraEmpty}
                  imageStyle={{
                    height: 100,
                  }}
                  description={<span>{t('No cameras to view!')}</span>}
                />
              )
            ) : (
              <Spinner/>
            )}
          </div>

          <DialPad
            open={dialPad?.show}
            onClose={() => {
              dispatch(
                changeDialPadData({
                  show: false,
                  phone: '',
                })
              );
            }}
            accountSip={sipAccount || {}}
            calledPhone={dialPad?.phone || ''}
          />
        </Layout>
      </Layout>
    </div>
  );
};

export default LivePage;
